import React from 'react';
import CmtCardFooter from '@coremat/CmtCard/CmtCardFooter';
import { Add, Edit, Delete } from '@material-ui/icons';
import { Box, Button } from '@material-ui/core';

export default function QuestionFooter({ question, handleRemove, handleUpdate, handleAdd }) {
  return (
    <CmtCardFooter separator={{ color: '#bdbdbd', borderWidth: 1, borderStyle: 'solid' }}>
      <Box>
        {question ? (
          <>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Delete />}
              onClick={handleRemove}
              style={{ marginRight: 14 }}>
              حذف
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Edit />}
              onClick={handleUpdate}
              style={{ marginRight: 14 }}>
              ویرایش
            </Button>
          </>
        ) : (
          <Button variant="outlined" color="primary" startIcon={<Add />} onClick={handleAdd} style={{ marginRight: 14 }}>
            اضافه کردن سوال
          </Button>
        )}
      </Box>
    </CmtCardFooter>
  );
}
